<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputRadio" });
import "tailwindcss/tailwind.css";
import Icon from "../../elements/icon/Icon.svelte";
import { onMount } from "svelte";
import { v4 as uuid } from "uuid";
export let value;
export let key;
export let name;
export let label = void 0;
export let isDisabled = false;
export let isRequired = false;
export let isIndeterminate = false;
export let style = "default";
export let css = "";
let id = "";
let isTouched = false;
$: isChecked = key === value;
const setTouched = () => {
    isTouched = true;
};
const onChange = (event) => {
    const TARGET = event.target;
    setTouched();
    key = TARGET.checked ? TARGET.value : void 0;
};
onMount(() => {
    id = uuid();
});
</script>

<input
    type = 'radio'
    checked = { isChecked }
    disabled = { isDisabled }
    required = { isRequired }
    indeterminate = { isIndeterminate }
    { value }
    { id }
    { name }
    on:change = { onChange }
    on:invalid = { setTouched }
/>

<label
    for = { id }
    class = { `s8-input-radio s8-${ style } ${ css }` }
    class:s8-touched = { isTouched }
>
    <slot>{ label }</slot>

    {#if style === 'datalist' && isChecked}
        <Icon key = 'check' />
    {/if}

</label>


<style>

    label {
        position: relative;
        width: 100%;
        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
                user-select: none;
    }

        label.s8-datalist {
            display: block;
            padding: 2px 5px;
            padding-right: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            transition: background-color 0.2s;
            border-radius: 5px;
        }

        label.s8-datalist :global(svg) {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 5px;
                height: 12px;
                stroke: rgba(68,131,95,1);
            }

        label.s8-default {
            padding: 10px;
            padding-left: 20px;
        }

        label.s8-default:before {
                position: absolute;
                top: calc(50% - 1px);
                left: 0px;
                transform: translateY(-50%);
                border: 1px solid transparent;
                border-radius: 20px;
                width: 12px;
                height: 12px;
                transition: border-color 0.3s, border-width 0.2s;
                content: '';
            }

    input {
        display: none;
    }

    input:checked + label.s8-datalist {
                background: rgba(68,131,95,0.06);
                color: rgba(68,131,95,0.72);
                cursor: default;
            }

    input:checked + label.s8-default:before {
                border-width: 4px;
                border-color: rgba(39,39,17,1);
            }

    input:not(:checked) + label.s8-default::before {
                border-color: rgba(39,39,17,0.24);
            }

    input:not(:checked):not(:disabled) + label:hover.s8-datalist {
                background-color: rgba(39,39,17,0.03);
            }

    input:not(:checked):not(:disabled) + label:hover.s8-default::before {
                border-color: rgba(39,39,17,1);
            }

    input:disabled + label {
            cursor: not-allowed !important;
            color: rgba(39,39,17,0.24);
        }

    input:disabled + label.s8-default::before {
                border-color: rgba(39,39,17,0.12);
            }

    input:invalid + label.s8-touched {
            color: rgba(239,35,59,1);
        }

    input:invalid + label.s8-touched.s8-default:before {
                border-color: rgba(239,35,59,1)
            }</style>